if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('.js-cart-terms-checkbox');
      if (!this.checkbox) return;

      const formId = this.checkbox.getAttribute('form');
      this.form = formId ? document.getElementById(formId) : this.closest('form');

      this._onSubmit = this._handleSubmit.bind(this);
      this._onChange = this._handleChange.bind(this);

      if (this.form) this.form.addEventListener('submit', this._onSubmit, true);
      this.checkbox.addEventListener('change', this._onChange);

      this._updateButtons();
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
      this.checkbox.removeEventListener('change', this._onChange);
    }

    _handleChange() {
      this._clearError();
      this._updateButtons();
    }

    _handleSubmit(evt) {
      if (!this.checkbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this._showError();
        this._updateButtons();
      }
    }

    _updateButtons() {
      const checked = this.checkbox.checked;
      this._getCheckoutButtons().forEach((btn) => {
        btn.disabled = !checked;
        btn.setAttribute('aria-disabled', checked ? 'false' : 'true');
        btn.classList.toggle('cart-checkout-disabled', !checked);
      });
    }

    _showError() {
      this.checkbox.setCustomValidity(theme.strings.cartTermsConfirmation);
      this.checkbox.reportValidity();

      if (!this.querySelector('.cart-terms-error')) {
        const el = document.createElement('div');
        el.className = 'cart-terms-error';
        el.textContent = theme.strings.cartTermsConfirmation;
        this.appendChild(el);
      }
    }

    _clearError() {
      this.checkbox.setCustomValidity('');
      const err = this.querySelector('.cart-terms-error');
      if (err) err.remove();
    }

    _getCheckoutButtons() {
      const formId = this.checkbox.getAttribute('form');
      if (formId) {
        return document.querySelectorAll(
          `button[name="checkout"][form="${formId}"], input[name="checkout"][form="${formId}"], button[name="checkout"]:not([form]), [name="checkout"][form="${formId}"]`
        );
      }
      return this.form
        ? this.form.querySelectorAll('button[name="checkout"], input[name="checkout"]')
        : [];
    }
  }

  customElements.define('cart-terms', CartTerms);
}
